export const LOGIN = 'user/LOGIN';
export const ERROR = 'user/ERROR';
export const USER_LIST = 'user/USER_LIST';
export const FLUSH = 'FLUSH';
export const LOGOUT = 'user/LOGOUT';
export const UPDATE_USER = 'user/UPDATE_USER';
export const MESSAGE = 'user/MESSAGE';
export const USER_DETAILS = 'user/USER_DETAILS';
export const USER_TYPES = 'user/USER_TYPES';
export const USER_REVIEWS = 'user/USER_REVIEWS';
export const USER_FRIENDS = 'user/USER_FRIENDS';
export const SHARE_PROFILE_USER_DETAILS = 'user/SHARE_PROFILE_USER_DETAILS';
export const SHARE_POST_DETAILS = 'user/SHARE_POST_DETAILS';
export const SHARE_PROPERTY_DETAILS = 'user/SHARE_PROPERTY_DETAILS';
export const PRIVACY_POLICY = 'user/PRIVACY_POLICY';
export const TERM_CONDITIONS = 'user/TERM_CONDITIONS';
export const TOTAL_USER = 'user/TOTAL_USER';